import React from "react";
import { Shield, AlertTriangle, BadgeCheck } from "lucide-react";

const cards = [
  {
    icon: AlertTriangle,
    title: "Emergency Button",
    body: "Instantly alert a trusted contact during any workout session. One tap, real-time location.",
    badge: "1-tap",
  },
  {
    icon: Shield,
    title: "Report & Block",
    body: "Report users and maintain a safe, respectful community. Reviewed by the trust team within 24h.",
    badge: "Always on",
  },
  {
    icon: BadgeCheck,
    title: "Identity Verification",
    body: "Optional verification badge to build trust before meeting. Real selfie + ID — gym-style honesty.",
    badge: "Verified",
  },
];

const Safety = () => {
  return (
    <section
      id="safety"
      data-testid="safety-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
            Safety & Control
          </p>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
            Train Safe.
            <br />
            <span className="text-[#C6FF00]">Stay In Control.</span>
          </h2>
          <p className="mt-6 text-base text-neutral-400 max-w-xl">
            Showing up means trusting who you're showing up with. We built the rails
            so you can focus on the work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                data-testid={`safety-card-${i}`}
                className="group relative bg-[#111] border border-white/5 hover:border-[#C6FF00]/40 rounded-2xl p-8 transition-all duration-500 overflow-hidden"
              >
                <div className="absolute -top-12 -right-12 w-40 h-40 bg-[#C6FF00]/0 group-hover:bg-[#C6FF00]/10 blur-3xl transition-all duration-700" />

                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-xl bg-[#C6FF00]/10 border border-[#C6FF00]/30 flex items-center justify-center">
                    <Icon className="text-[#C6FF00]" size={24} strokeWidth={2} />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-semibold border border-white/10 rounded-full px-2.5 py-1">
                    {c.badge}
                  </span>
                </div>

                <h3 className="font-heading text-3xl text-white tracking-wide mb-3">
                  {c.title}
                </h3>
                <p className="text-sm text-neutral-400 leading-relaxed">{c.body}</p>

                <div className="mt-8 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-neutral-500 group-hover:text-[#C6FF00] transition-colors">
                  <span className="font-bold">0{i + 1}</span>
                  <span className="h-px flex-1 bg-white/10 group-hover:bg-[#C6FF00]/40 transition-colors" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Safety;
